<template>
    <div class="c-reservation-main">
        <div class="c-reservation-main__select">
            <ReservationSelect />
        </div>

        <div class="c-reservation-main__product">
            <ReservationProduct />
        </div>

        <div class="c-reservation-main__form">
            <ReservationForm />
        </div>

        <div class="c-reservation-main__summary">
            <ReservationSummary />
        </div>
    </div>
</template>

<script>
import ReservationProduct from 'VueComponents/BranchReservation/ReservationProduct';
import ReservationSummary from 'VueComponents/BranchReservation/ReservationSummary';
import ReservationSelect from 'VueComponents/BranchReservation/ReservationSelect';
import ReservationForm from 'VueComponents/BranchReservation/ReservationForm';

export default {
    components: {
        ReservationProduct,
        ReservationSummary,
        ReservationSelect,
        ReservationForm,
    },
}
</script>
